document.getElementById('xml_export_button')?.addEventListener('click', async (e) => {
  e.preventDefault();

  const { nonce } = e.currentTarget.dataset;
  const type = e.currentTarget.dataset?.type || '';

  await axiosDownloadXml(nonce, type);
});

// Main request
const axiosDownloadXml = async (nonce, type) => {
  try {
    const { data, headers } = await axios.post(
      localData.siteURL,
      {
        action: 'renderXML',
        id: localData.id,
        nonce,
        type,
      },
      {
        responseType: 'blob',
      },
    );

    const blob = new Blob([data]);

    const filename = getFilenameFromHeaders(headers) || 'export.xml';

    triggerDownload(blob, filename);
  } catch (err) {
    console.error('XML download failed:', err);
  }
};

// Extract filename from response headers
const getFilenameFromHeaders = (headers) => {
  const disposition = headers?.['content-disposition'];

  return disposition?.match(/filename="(.+)"/)?.[1];
};

// Trigger browser download
const triggerDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};
